const u = "ap", _ = "is-", o = (s, e, c, a, $) => {
  let n = `${s}-${e}`;
  return c && (n += `-${c}`), a && (n += `__${a}`), $ && (n += `--${$}`), n;
}, i = (s) => {
  const e = u;
  return {
    b: (t = "") => o(e, s, t, "", ""),
    e: (t) => t ? o(e, s, "", t, "") : "",
    m: (t) => t ? o(e, s, "", "", t) : "",
    is: (t, ...r) => {
      const p = r.length >= 1 ? r[0] : !0;
      return t && p ? `${_}${t}` : "";
    }
  };
};
export {
  u as defaultNamespace,
  i as useNamespace
};
